import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { parseProblem } from '../http/api-problem';
import { ReauthenticationService } from './reauthentication.service';

/**
 * Operazioni sensibili (research R-10, FR-031): un 403 `reauthentication_required` apre la
 * finestra "Conferma la tua identità" e, confermata l'identità, ripete una volta la richiesta
 * originale, così l'utente non deve ricominciare. Se annulla, arriva l'errore originale.
 *
 * Le richieste di `/api/auth/` sono escluse: la conferma stessa passa da lì.
 */
export const reauthenticationInterceptor: HttpInterceptorFn = (request, next) => {
  const reauthentication = inject(ReauthenticationService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 403 &&
        !request.url.startsWith('/api/auth/') &&
        parseProblem(error).code === 'reauthentication_required'
      ) {
        return from(reauthentication.confirm()).pipe(
          switchMap((confirmed) => (confirmed ? next(request) : throwError(() => error))),
        );
      }
      return throwError(() => error);
    }),
  );
};
